// Pure visibility rules — testable, no React.
// A question is hidden when its `show_if` guard fails:
//   { sex: 'Female' }              -> hidden unless Biological gender = Female
//   { answer: '<id>', eq: 'Yes' }  -> hidden unless that controlling answer === eq
// Sex is read from the captured `gender` answer (Client Information, early in the flow).

export function isVisible(item, answers = {}, profile = {}) {
  const s = item.show_if;
  if (!s) return true;
  if (s.sex) {
    const gender = profile.gender ?? answers.gender;
    if (gender !== s.sex) return false;
  }
  if (s.answer) {
    if (answers[s.answer] !== s.eq) return false;
  }
  return true;
}

// Phase gate (structural, applied when screens are built): PRE is always in, POST
// only once the account is enrolled, CUT never renders.
export function isItemInPhase(item, enrolled = false) {
  const phase = item.phase || 'PRE';
  if (phase === 'CUT') return false;
  if (phase === 'POST') return !!enrolled;
  return true;
}

// Coach gate (structural, applied alongside the phase gate). A SEPARATE axis from
// phase: phase is the PRE/POST release wave driven by purchase, this is one client's
// readiness as judged by a coach. Kept as its own predicate so `isItemInPhase` keeps
// meaning exactly what it always meant.
//
// Fail-closed: anything carrying the gate stays hidden unless we were explicitly
// told it is open.
export function isItemUnlocked(item, section, { additionalInfoEnabled = false } = {}) {
  const gated =
    section?.gate === 'additional_info' || item?.gate === 'additional_info';
  if (!gated) return true;
  return !!additionalInfoEnabled;
}
